import { useQuery } from '@tanstack/react-query'

import { ticketInstance } from '@/modules/tickets'

export function getTicketDetailQueryKey(ticketId?: string) {
  const baseKey = 'getTicket'
  return ticketId ? [baseKey, ticketId] : [baseKey]
}

export function useTicketDetailQuery(ticketId: string) {
  return useQuery({
    queryKey: getTicketDetailQueryKey(ticketId),
    queryFn: async () => await ticketInstance.ticketDetail(ticketId)
  })
}
